var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIconDisable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9994 12V19.88C14.0394 20.18 13.9394 20.5 13.7094 20.71C13.3194 21.1 12.6894 21.1 12.2994 20.71L10.2894 18.7C10.0594 18.47 9.95937 18.16 9.99937 17.87V12H9.96937L4.20937 4.62C3.86937 4.19 3.94937 3.56 4.37937 3.22C4.56937 3.08 4.77937 3 4.99937 3H18.9994C19.2194 3 19.4294 3.08 19.6194 3.22C20.0494 3.56 20.1294 4.19 19.7894 4.62L14.0294 12H13.9994Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconDisable);
export default __webpack_public_path__ + "static/media/filter-icon-disable.02c883e4b4a083a5f2a8c5313e1fd3ca.svg";
export { ForwardRef as ReactComponent };